// Store
import { Action, ActionReducer, StoreConfig } from "@ngrx/store";
// Utils
import { CommonService } from "@core/utils";

/**
 * Meta-reducer factory function
 * @export
 * @param {string} localStorageKey
 * @param {CommonService} commonService
 * @returns {StoreConfig<any>}
 */
export function getMetaReducerFactory(localStorageKey: string, commonService: CommonService): StoreConfig<any> {
    return {
        initialState: () => {
            return commonService.getFromLocalStorage(localStorageKey);
        },
        metaReducers: [
            storageMetaReducer(localStorageKey, commonService)
        ],
    };
}

/**
 * Storage Meta Reducer Middlelayer function between Action and Reducer
 * @export
 * @template S
 * @template A
 * @param {string} key
 * @param {CommonService} commonService
 * @returns
 */
export function storageMetaReducer<S, A extends Action = Action>(key: string, commonService: CommonService) {
    return (reducer: ActionReducer<any>): ActionReducer<any> => {
        let lastPersisted: any;

        return (state, action) => {
            const nextState = reducer(state, action);

            if (nextState !== lastPersisted) {
                lastPersisted = nextState;
                commonService.setIntoLocalStorage(key, nextState);
            }

            return nextState;
        };
    };
}